const $ = global.$ || global.jQuery || require('jquery');

/**
 * A visual component that extends the base SelectableItemSelector component to support the
 * {@link VariablesModel}.
 */
import SelectableItemSelectorComponent from './selectable-item-selector';
const ID = 'variable-selector';
const TITLE_FIELD = 'title';

export default class VariableSelectorComponent extends SelectableItemSelectorComponent {

  /**
   * Constructor.
   *
   * @param $parent JQuery object representing the parent element in which this component will be
   * inserted.
   * @param variablesModel the underlying model that this component visually represents.
   */
  constructor($parent, variablesModel) {
    super(ID, $parent, variablesModel, TITLE_FIELD);

    // Handle changes to the Variables model.
    variablesModel.on(variablesModel.ON_LIST_CHANGE_EVENT, function() {
      this._render();
    }.bind(this));
  };

}



// WEBPACK FOOTER //
// ./src/app/map/components/variable-selector.js